import { render, staticRenderFns } from "./AppInputTextarea.vue?vue&type=template&id=5e51e5ec"
import script from "./AppInputTextarea.vue?vue&type=script&lang=js"
export * from "./AppInputTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports